import logo from './logo.svg';
import './App.css';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GameWrapper } from './GameWrapper';
import BunnyGame from './BunnyGame';
import PrimePathGame from './Prime2357';
import PrimePathPage from './PrimePathPage';
import MasterPage from './MasterPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import BunnyHop from './BunnyHop/BunnyHop';

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
}

function App() {
  return (
  <div >
    
    <Router>
    <PageViewTracker />
      <Routes>
      <Route path='/' element={<MasterPage/>}>      
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/bunny-escape" element={<BunnyGame />} />
          <Route path="/2357-prime" element={<PrimePathGame />} />
          <Route path="/prime-path" element={<PrimePathPage />} />
          {/* <Route path="/bunny-hop" element={<BunnyHop />} /> */}
          <Route path="/about" element={<AboutPage />} />
       </Route>
      </Routes>
    </Router>
  </div>
  );
}

export default App;
